import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 1100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Container = styled.div`
  background: white;
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: ${slideUp} 0.3s ease-out;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background: #111827;
  padding: 20px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    color: #d4af37;
    margin: 0;
    font-size: 18px;
    font-weight: 700;
  }

  button {
    background: transparent;
    border: none;
    color: #9ca3af;
    font-size: 20px;
    cursor: pointer;
    transition: color 0.2s;
    &:hover {
      color: white;
    }
  }
`;

export const Body = styled.div`
  padding: 25px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }

  span.label {
    color: #6b7280;
    font-size: 14px;
    font-weight: 500;
  }

  span.value {
    color: #111827;
    font-weight: 600;
    font-size: 15px;
    text-align: right;

    &.highlight {
      color: #059669;
      font-weight: 700;
    }
  }
`;

export const StatusBadge = styled.span`
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;

  ${(props) => {
    switch (props.status) {
      case "PENDING":
        return `background: #fff7ed; color: #c2410c; border: 1px solid #ffedd5;`;
      case "PAID":
        return `background: #ecfdf5; color: #047857; border: 1px solid #d1fae5;`;
      case "CANCELED":
        return `background: #f3f4f6; color: #4b5563; border: 1px solid #e5e7eb;`;
      case "REJECTED":
        return `background: #fef2f2; color: #b91c1c; border: 1px solid #fee2e2;`;
      default:
        return `background: #f3f4f6; color: #374151;`;
    }
  }}
`;

export const Footer = styled.div`
  padding: 20px 25px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
`;

export const Button = styled.button`
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;

  ${(props) =>
    props.cancel
      ? `
      background: #fee2e2;
      color: #b91c1c;
      &:hover { background: #fecaca; }
    `
      : `
      background: #e5e7eb;
      color: #374151;
      &:hover { background: #d1d5db; }
    `}
`;
